const LINKEDIN_URL = "https://ca.linkedin.com/in/jasreen-mander-1125a825a";

const ARTSTATION_URL = "https://www.artstation.com/jasreen_mander";

export { LINKEDIN_URL, ARTSTATION_URL };
